export default "__VITE_PUBLIC_ASSET__72b07914__"